type TargetingMap = Record<string, string | string[]>;

class TargetingManager {
  /**
   * Apply page-level targeting.
   * Uses new GPT API (setConfig) with fallback to legacy pubads().setTargeting.
   */
  static setPageTargeting(targeting: TargetingMap) {
    if (!window.googletag) return;

    window.googletag.setConfig({
        targeting: targeting,
    });
  }

  /**
   * Apply slot-level targeting.
   * Uses new GPT API (updateConfig) with fallback to legacy slot.setTargeting.
   */
  static setSlotTargeting(slot: googletag.Slot, targeting: TargetingMap) {
    if (!slot) return;
      (slot as any).setConfig({
        targeting: targeting,
      });
    
  }

}

export default TargetingManager;
